import { render } from "./ro-content.vue?vue&type=template&id=544aa09c"
import script from "./ro-content.vue?vue&type=script&lang=js"
export * from "./ro-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__